import {
  combinedSettingsSelector,
  combinedStyleSelector,
  getCornersRadiusSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import { createSelector } from "reselect";

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const radiusSelector = getCornersRadiusSelector(TargetSelector.Entity, "icon");
  const styleSelector = combinedStyleSelector(TargetSelector.Entity, ["border"], "icon");

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "useBrandColor", path: "icon", prop: "useBrandColor" },
    { name: "color", path: "icon", prop: "color", type: "color" },
    { name: "backgroundColor", path: "icon", prop: "backgroundColor", type: "color" }
  ]);

  return createSelector(
    [settingsSelector, radiusSelector, styleSelector],
    (settings, radius, style): React.CSSProperties => ({
      ...style,
      borderRadius: radius,
      ...(settings.useBrandColor
        ? {}
        : {
            color: settings.color,
            backgroundColor: settings.backgroundColor
          })
    })
  );
};
